import { PrizesBlock } from '@sorare/core/src/components/landing/PrizesBlock';

import { CashRewardMLB } from './CashRewardMLB';
import { MerchPrize } from './MerchPrize';
import { VIPGamePrize } from './VIPGamePrize';

export const Prizes = () => {
  return (
    <PrizesBlock>
      <VIPGamePrize />
      <CashRewardMLB />
      <MerchPrize />
    </PrizesBlock>
  );
};
